import { i18n } from "@lingui/core";
import { t, Trans } from '@lingui/macro';
import { ArrowLeft } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useHistory } from '../../hooks/useRouterCompat';
import { Fire } from '../../services/FireClient';
import { My } from '../../services/My';
import { defaultLanguage } from '../../locales/InitTranslation';
import { Button } from '../../components/ui/button';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../../components/ui/select";

export class Keys {
    static KO = 'ko';
    static EN = 'en';
    static JA = 'ja';
}

const AccountLanguagePage: React.FC = () => {
    const [language, setLanguage] = useState(My.user.lang ?? defaultLanguage);
    const history = useHistory();
    const [inProgress, setInProgress] = useState(false);

    useEffect(() => {
        setLanguage(My.user.lang ?? defaultLanguage);
    }, []);

    async function submitHandler() {
        setInProgress(true);
        if (My.user.lang !== language) {
            My.user.lang = language;
            i18n.activate(My.user.lang);
        }

        await Fire.saveCurrentUser(My.user);
        setInProgress(false);
        history.replace('/');
    }

    return (
        <div className="flex flex-col h-screen bg-slate-50">
            <header className="flex items-center px-4 h-14 border-b bg-white shrink-0 gap-2">
                <Button variant="ghost" size="icon" onClick={() => history.goBack()}>
                    <ArrowLeft className="w-5 h-5" />
                </Button>
                <h1 className="text-lg font-semibold flex-1 text-center"><Trans>Account language</Trans></h1>
                <Button
                    onClick={submitHandler}
                    disabled={inProgress}
                    variant="ghost"
                    className="text-primary hover:text-primary/90 font-medium"
                >
                    <Trans>Save</Trans>
                </Button>
            </header>

            {inProgress && (
                <div className="h-1 w-full bg-gray-100 overflow-hidden">
                    <div className="h-full bg-primary animate-progress" />
                </div>
            )}

            {My.isLoggedIn() && (
                <div className="flex-1 p-4">
                    <div className="max-w-md mx-auto space-y-2">
                        <h2 className="text-sm font-medium text-gray-500 px-1">
                            <Trans>Set the language for your user interface</Trans>
                        </h2>
                        <div className="bg-white rounded-lg border shadow-sm p-4">
                            <Select value={language} onValueChange={setLanguage}>
                                <SelectTrigger className="w-full">
                                    <SelectValue placeholder={t`Set the language for your user interface`} />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value={Keys.EN}>English</SelectItem>
                                    <SelectItem value={Keys.KO}>한국어</SelectItem>
                                    <SelectItem value={Keys.JA}>日本語</SelectItem>
                                </SelectContent>
                            </Select>
                            <label className="text-xs text-muted-foreground mt-2 block px-1">
                                <Trans>language</Trans>
                            </label>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AccountLanguagePage;